// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2723":"3c9272a1","5071":"1700dfe8"}[chunkId] + ".chunk.css";
};